module.exports = __webpack_public_path__ + "img/book.e6c9b579.png";